<template>
<div :class="['navMenuContainer',menuCollapse ? 'navMenuCollapseContainer' : '']">
  <label v-for="(navMenu, index) in navMenuList" :key="index">
    <el-menu-item :class="'itemLevel' + level" v-if="navMenu.children == null" :key="navMenu.id" :data="navMenu" :index="navMenu.componentUrl ? navMenu.componentUrl : ''" :route="navMenu.componentUrl">
      <i class="menuIcon imgBox" v-if="navMenu.parentId == 0&&navMenu.icon">
        <img v-if="(menuNa?menuNa:newmenuNa) == navMenu.name" :src="require('../../assets/img/'+navMenu.icon.split('.')[0]+'On.png')" alt="">
        <img v-else :src="require('../../assets/img/'+navMenu.icon)" alt="">
      </i>
      <span slot="title" :title="navMenu.name">{{navMenu.name? navMenu.name:'' }}</span>
    </el-menu-item>
    <el-submenu :class="'subLevel' + level" v-if="navMenu.children != null" :key="navMenu.id" :data="navMenu" :index="navMenu.id+''" @click.native="getMenuMess(navMenu)">
      <template slot="title">
        <i class="menuIcon imgBox" v-if="navMenu.parentId == 0&&navMenu.icon">
          <img v-if="(menuNa?menuNa:newmenuNa) == navMenu.name" :src="require('../../assets/img/'+navMenu.icon.split('.')[0]+'On.png')" alt="">
          <img v-else :src="require('../../assets/img/'+navMenu.icon)" alt="">
        </i>
        <span class="title" :title="navMenu.name">{{ navMenu.name }}</span>
      </template>
      <NavMenu :navMenus="navMenu.children" :level='(+level)+1'></NavMenu>
    </el-submenu>
  </label>
</div>
</template>

<script>
import NavMenu from "@/components/layout/NavMenu";
export default {
  components: {
    NavMenu
  },
  name: "NavMenu",
  props: ["navMenus", "level"],
  data() {
    return {
      navMenuList: [],
      routerPath: "",
      menuNameList:{},
      sendMess:false,
      menuNa:'',
      newmenuNa:'',
      tenant: null
    };
  },
  watch: {
    navMenus() {
      this.navMenuList = this.reSetMenuData(this.navMenus)
      
      // console.log(this.navMenuList);
    },
    menuName(curval, oldval) {
      // console.log(curval);
      this.fiterChildren(curval)
      // console.log(this.sendMess);
      if(this.sendMess){
        this.menuNa = curval.name
      } else {
        this.newmenuNa = curval.name
      }
      // console.log(this.menuNa);
    },
    $route(nVal) {
      // console.log(this.newmenuNa);
      if(this.newmenuNa&&!this.sendMess){
        this.menuNa = this.newmenuNa
      } else {
        this.newmenuNa = ''
      }
      // console.log(this.menuNa);
      // console.log(nVal);
      this.routerPath = nVal.path;
    }
  },
  // filters: {
  //   formatUrl: function (value) {
  //     // return value.subs;
  //   }
  // },
  computed: {
    menuCollapse() {
      return this.$store.state.menuIsCollapse
    },
    menuName(){
      return this.$store.state.menuName
    }
  },
  mounted() {
    this.tenant = this.storage.getSession('tenant')

    this.routerPath = this.$route.path;
    this.navMenuList = this.reSetMenuData(this.navMenus)
  },
  methods: {
    getMenuMess(data){
      // console.log(data);
      this.menuNameList=data
      this.$store.dispatch('setMenuName',this.menuNameList)
    },
    fiterChildren(param){
      let flag = true
      if (param.children != null) {
        param.children.forEach(value => {
          if ('/' + this.$route.name == value.componentUrl) {
            flag = false 
            this.sendMess = true
          }
          if(flag){
            if(value.children!= null){
              flag = false
            //   console.log(666);
              this.fiterChildren(value)
            }
          }
        })
      }
      if(flag){
        this.sendMess = false
      }
    },
    /**
     * @Description 过滤菜单：tenant为false时，即使接口有数据推送菜单项也不显示
     * @Author      YOYO     -    2022-07-07
     * @param       {Object} menu [接口数据菜单]
     * @return      {Object}      [过滤后的菜单]
     */
    reSetMenuData (menu) {
      let tempMenu = menu.map(item => {
        if (item.name == '系统管理') {
          if (!this.tenant) {
            let tempChild = item.children.filter(({ componentUrl }) => componentUrl != '/datasend')
            item.children = tempChild
          }
        }
        return item
      })
      return tempMenu
    }
  }
};
</script>

<style lang="scss" scoped>
.navMenuContainer {
  font-family: AlibabaPuHuiTi-Medium;
  .el-menu-item {
    height: 36px;
    line-height: 36px;
    // padding: 0 10px !important;
    border-radius: 2px;
    span {
      color: rgba(255, 255, 255, 1);
    }
  }

  .menuIcon {
    width: 24px;
    height: 24px;
    display: inline-block;
    margin-right: 16px;
  }
}
</style><style lang="scss">
.navMenuContainer {
  .el-menu-item {
    &.itemLevel1 {
      margin: 10px 0;
    }

    &.is-active {
      // background: #1089FF !important;

      span {
        color: #1089FF;
      }

      .menuIcon {
        opacity: 1;
      }
    }
    &.itemLevel2 {
      &.is-active{
        position: relative;
        &::after {
          position: absolute;
          width: 2px;
          height: 16px;
          content: '';
          background: #1089FF;
          left: 28px;
          top: 50%;
          margin-top: -7px;
        }
      }
    }
  }

  .el-submenu {
    .el-submenu__title {
      height: 36px;
      line-height: 36px;
      padding: 0 10px 0 20px !important;
      border-radius: 2px;

      span {
        color: rgba(255, 255, 255, 1);
      }

      .el-submenu__icon-arrow {
        right: 16px;
        color: rgba(255, 255, 255, 1);
        margin-top: -6px;

        &::before {
          content: '\e790'
        }
      }
    }

    &.subLevel1 {
      &>.el-submenu__title {
        padding: 0 15px 0 20px !important;
        margin-top: 10px;
      }

      &.is-active {
        &>.el-submenu__title {
          padding:0 10px 0 15px !important;
          span {
            color: #1089FF;
          }

          .menuIcon {
            opacity: 1;
            width: 34px;
            height: 34px;
            margin-right: 10px !important;
          }

          .el-submenu__icon-arrow {
            color: #1089FF
          }
        }
      }

      .el-menu-item {
        margin-top: 10px;
        padding-left: 68px !important;
      }
    }

    &.subLevel2 {
      &>.el-submenu__title {
        padding: 0 68px !important;
        margin-top: 10px;
      }

      &.is-active {
        .el-submenu__title {
          span {
            color: #1089FF;
          }

          .el-submenu__icon-arrow {
            color: #1089FF
          }

          // background: #1089FF !important;
        }
      }

      .el-menu-item {
        padding-left: 76px !important;
        margin-top: 10px;

        &.is-active {
          background: none !important;
          position: relative;

          &::after {
            position: absolute;
            width: 2px;
            height: 16px;
            content: '';
            background: #1089FF;
            left: 28px;
            top: 50%;
            margin-top: -7px;
          }
        }
      }
    }
  }

}
.navMenuCollapseContainer {
    .el-submenu {
        &.subLevel1 {
            .el-submenu__title {
                .el-submenu__icon-arrow {
                    display: none;
                }
            }
        }
    }
    .el-menu-item{
      &.is-active{
        &::after {
          display: none;
        }
      }
    }
}
</style>
